(() => {
  const allowedHandles = new Set((document.body?.dataset.nupVisiblePacks || '')
    .split(',')
    .map((handle) => handle.trim().toLowerCase())
    .filter(Boolean));
  const handleToken = /(^|[-_])(duo|trio|family|familia)([-_]|$)/i;
  const titleToken = /^\s*(duo|dúo|trio|trío|family|familia)\b/i;

  const getHandle = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/^\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  };

  const isLegacyProductLink = (link) => {
    const handle = getHandle(link.getAttribute('href') || '');
    if (!handle || allowedHandles.has(handle)) return false;
    if (handleToken.test(handle)) return true;
    return titleToken.test((link.textContent || '').trim());
  };

  const removeLegacyLinks = (root = document) => {
    root.querySelectorAll?.('a[href*="/products/"]').forEach((link) => {
      if (!isLegacyProductLink(link)) return;
      const target =
        link.closest('.predictive-search__list-item') ||
        link.closest('.grid__item') ||
        link.closest('.slider__slide') ||
        link.closest('.card-wrapper') ||
        link.closest('li') ||
        link;
      target.remove();
    });
  };

  const redirectLegacyProduct = () => {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/i);
    if (!match) return false;

    const handle = decodeURIComponent(match[1]);
    if (allowedHandles.has(handle) || !handleToken.test(handle)) return false;

    let baseHandle = handle
      .replace(/^(duo|trio|family|familia)-/i, '')
      .replace(/-(duo|trio|family|familia)$/i, '');

    if (!baseHandle || baseHandle === handle) {
      window.location.replace('/collections/nup-cyber-2026');
      return true;
    }

    window.location.replace('/products/' + encodeURIComponent(baseHandle));
    return true;
  };

  if (redirectLegacyProduct()) return;

  const run = () => removeLegacyLinks(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) removeLegacyLinks(node);
        });
      });
    });
    observer.observe(document.documentElement, { subtree: true, childList: true });
  }
})();
